<template>
  <div>
    <a-card :bordered="false">
      {{saying}}
      <div class="icon">
        <a :href="github" target="blank">
          <a-icon type="github" />
        </a>
        <!-- <a-divider type="vertical"></a-divider> -->
        <a :href="gitee" target="_blank">
          <GiteeIcon />
        </a>
      </div>
    </a-card>
  </div>
</template>

<script>
import {mapState} from 'vuex';
const GiteeIcon = {
  name: "gitee",
  // eslint-disable-next-line no-unused-vars
  render(h) {
    return (
      <i class="anticon anticon-github">
        <svg
          width="1em"
          height="1em"
          fill="currentColor"
          viewBox="0 0 1024 1024"
        >
          <path d="M512 1000.12c-268.466 0-488.12-219.654-488.12-488.12S243.533 23.88 512 23.88 1000.12 243.533 1000.12 512 780.467 1000.12 512 1000.12z m247.111-543.034H481.492c-12.203 0-24.406 12.203-24.406 24.406v61.016c0 12.203 12.203 24.406 24.406 24.406h167.792c12.203 0 24.406 12.203 24.406 24.406v12.203c0 39.66-33.558 73.218-73.218 73.218H371.665c-12.203 0-24.406-12.203-24.406-24.406V420.477c0-39.66 33.559-73.218 73.218-73.218h338.634c12.203 0 24.406-12.203 24.406-24.406v-61.015c0-12.203-12.203-24.406-24.406-24.406H420.477c-100.675 0-179.994 82.37-179.994 179.995V756.06c0 12.203 12.203 24.406 24.406 24.406h356.938c88.472 0 161.69-73.218 161.69-161.69V481.492c0-12.203-12.203-24.406-24.406-24.406z" />
        </svg>
      </i>
    );
  }
};
export default {
  name: "author",
  data() {
    return {
      // saying: `不慕往，不闵来，无邑怜之心，当时则动，物至而应，事起而辨，治乱可否，昭然明矣。——《荀子》`
    };
  },
  computed: {
    ...mapState(["meta"]),
    github() {
      return this.meta.github 
    },
    gitee() {
      return this.meta.gitee 
    },
    saying() {
      return this.meta.author_saying 
    },
  },
  components: {
    GiteeIcon,
  }
};
</script>

<style lang="scss" scoped>
.icon {
  text-align: center;
  font-size: 1.5rem;
  
  a{
    margin-right: .8rem;
    color: #ccc;
  }
  a :hover{
    color: #257cee;
  }
}
</style>